import React from 'react';
import { CircleXIcon } from 'lucide-react';
import { Section } from './Shared';
import { DecorativeDandelions } from './DecorativeDandelions';
const points = ['Tus pacientes mejoran emocionalmente pero el cuerpo no acompaña el proceso.', 'No tenés un protocolo concreto para entregarles entre sesión y sesión.', 'Recomendás plantas sin una guía técnica que respalde tus indicaciones.', 'Sin entender la conexión emocional del hígado, trabajás el síntoma pero no la raíz.', 'Tus consultantes abandonan el proceso porque no tienen una hoja de ruta diaria.', 'Cada consulta empieza desde cero porque el paciente no tuvo herramientas entre sesiones.'];
export function PainPoints() {
  return <Section className="max-w-4xl" data-id="element-247" data-mp="1syeofw4z5s40">
      <DecorativeDandelions className="-right-40 top-24 hidden h-72 w-48 lg:block" data-id="element-248" data-mp="1szg46dwxr2s2" />
      <header className="mx-auto mb-10 max-w-3xl text-center" data-id="element-249" data-mp="3iemjtvqlvz7i">
        <h2 className="font-display text-4xl font-bold leading-tight text-brand-dark md:text-5xl" data-id="element-250" data-mp="3nco068wndkfa">
          ¿Cuántas sesiones más vas a terminar sintiendo que le falta algo a tu
          abordaje?
        </h2>
        <p className="mt-6 text-sm leading-relaxed text-brand-text md:text-base" data-id="element-251" data-mp="1u1u2f49st2m5">
          Trabajás el cuerpo, las emociones y la energía, pero el cansancio, la
          inflamación y la digestión de tus pacientes siguen sin resolverse. No
          es falta de capacidad. Es falta de una herramienta específica. Y esa
          herramienta existe hoy.
        </p>
        <p className="mt-4 text-sm leading-relaxed text-brand-text md:text-base" data-id="element-252" data-mp="1g3x2pz01sg39"></p>
      </header>
      <div className="glass-panel rounded-3xl border-brand-green/20 p-6 md:p-9" data-id="element-253" data-mp="1b4supbov0oei">
        <h3 className="mb-6 font-serif text-lg font-bold text-brand-dark" data-id="element-254" data-mp="1p4251uqdwoak">
          Lo que pasa en tu consultorio sin el Código Hepático:
        </h3>
        <ul className="space-y-4" data-id="element-255" data-mp="30h4ocxjvbryf">
          {points.map(point => <li key={point} className="flex gap-3 text-sm leading-relaxed text-brand-text md:text-base" data-id="element-256" data-mp="30jqvwx6re7gn">
              <CircleXIcon className="mt-0.5 h-5 w-5 shrink-0 text-[#B35C32]" data-id="element-257" data-mp="2vknox777xr61" />
              {point}
            </li>)}
        </ul>
      </div>
      <p className="mx-auto mt-10 max-w-[317px] text-center font-display text-2xl font-bold italic text-brand-green md:max-w-2xl md:text-3xl" data-id="element-258" data-mp="1y3q902kj97ia">
        ¿Y si a partir de hoy cada sesión tuviera una herramienta concreta para
        continuar en casa?
      </p>
    </Section>;
}